import React from "react";
class QcIndividual extends React.Component {
  render() {
    return (
      <div className="heading-bottom-line ml-3 pt-4">
        <h1 className="txt-violet fw-normal fs18">Qc Individual</h1>

        <br />
        <br />
        <br />

        <h2 align="center"> Page under construction.. </h2>
      </div>
    );
  }
}

export default QcIndividual;
